import { render, staticRenderFns } from "./VCard.vue?vue&type=template&id=ada639b0&scoped=true"
import script from "./VCard.vue?vue&type=script&lang=js"
export * from "./VCard.vue?vue&type=script&lang=js"
import style0 from "./VCard.vue?vue&type=style&index=0&id=ada639b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada639b0",
  null
  
)

export default component.exports